/**
 * Componente Loader (Cargador)
 * 
 * Muestra un indicador de carga mientras se obtienen datos.
 * Puede mostrar un mensaje personalizado.
 * 
 * Uso:
 * <Loader message="Cargando datos..." />
 */

import React from 'react';

export interface LoaderProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
}

const LOADER_SIZES = {
  sm: 'w-4 h-4',
  md: 'w-8 h-8',
  lg: 'w-12 h-12',
};

export function Loader({ 
  message = 'Cargando...', 
  size = 'md',
  fullScreen = false,
}: LoaderProps) {
  const containerClasses = fullScreen
    ? 'fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50'
    : 'flex items-center justify-center p-8';

  return (
    <div className={containerClasses}>
      <div className="flex flex-col items-center gap-4">
        <div 
          className={`${LOADER_SIZES[size]} border-4 border-[#0196A1] border-t-transparent rounded-full animate-spin`}
          role="status"
          aria-label="Cargando"
        />
        {message && (
          <p className="text-sm text-gray-600">{message}</p>
        )}
      </div>
    </div>
  );
}

export default Loader;
